export default __webpack_public_path__ + "static/media/yo_0.dd56e435.mp3";